<template>
  <div style="padding-bottom: 50px">
    <div v-if='rank' class="flex align-center justify-around padding-sm">
      <div class="yellow-btn radio" @click="dialogVisible = true"><i class="iconfont iconjia1"></i>创建知识库</div>
      <div class='yellow-btn active radio' @click="rank=false">排序</div>
    </div>

    <div v-else class="flex align-center justify-around padding-sm">
      <div class='yellow-btn radio' @click='queding'>确定</div>
      <div class='yellow-btn radio active' @click="rank=true">取消</div>
    </div>

    <div class="zhishiku-item" v-for="(item,index) in zskList" :key="item.id">
      <div class="zsk-item-tit" :class="item.id === zskid?'active':''">
        <i class="iconfont "
           :class="item.open?'iconcaretdown':'iconcaretright'"
           @click="GetFolderList(item.id,index,item.open,item.system)"
           style="padding-right: 10px;color: #999;"></i>
        <i v-if="item.id === zskid && item.icon === 'icon24gf-folder'" class="iconfont icon24gf-folderOpen"
           :class="item.icon" style="font-size: 24px;"></i>
        <i v-else class="iconfont " :class="item.icon" style="font-size: 24px;"></i>
        <span @click="isopen(item.open,index,item.system)">{{ item.name }}</span>
        <div class="iconfont iconsangedian-type-1"
             v-if="(item.system === 3 || item.system === 5) && rank"
             @click="item.showSet = !item.showSet"
             style="display:block;width: 40px;height: 40px;text-align: center;line-height: 40px;color: #0a2240;cursor: pointer;position: relative">
          <div class="set-btn" v-if="item.showSet">
            <el-button round @click="editFile(item.name,item.id)" >
              修改知识库名称
            </el-button>
            <el-button round  @click="delFile(item.id)">
              删除知识库
            </el-button>
          </div>
        </div>
      </div>
      <div class='jiantoudi' v-if="!rank && item.share === 0">
        <span style="color: #fff;" class='jiantou1 iconfont iconjiantou1-copy' @click='paixu(index)'></span>
        <span style="color: #fff;" class='jiantou iconfont iconxiajiantou1' @click='paixu2(index)'></span>
      </div>
      <el-tree
        v-if="item.list.length>0 && item.system !== 4"
        :ref="'vueTree'+index"
        :data="item.list"
        :props="defaultProps"
        node-key='id'
        :highlight-current="item.highlightCurrent"
        :expand-on-click-node="false"
        :default-expand-all="false"
        @node-click="handleNodeClick"
        v-show="item.open"></el-tree>
    </div>

    <el-dialog
      title="创建知识库"
      :visible.sync="dialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div>
        <el-input v-model="addName" placeholder="请输入知识库名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addZsk">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改知识库的弹窗 -->
    <el-dialog title="修改知识库" :visible.sync="dialogZsk" width="40%" :close-on-click-modal="false">
      <div>
        <el-input v-model="zskName" placeholder="请输入知识库名称"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeZsk()">取 消</el-button>
        <el-button type="primary" @click="commitZsk()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import Vue from 'vue'

export default {

  name: "leftAside",
  data() {
    return {
      rank: true,
      dialogVisible: false,      //  创建知识库
      addName: '',                 //  创建知识库名称
      zskList: [
        // {
        //   id: 0,
        //   name: '分享给我的',
        //   icon: 'iconfenxiang',
        //   open: false,
        //   highlightCurrent: false,
        //   list: []
        // }
      ],

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      zskid: '',
      cid: '',
      zskName: '',
      zskId: '',
      dialogZsk: false
    }
  },
  computed: {
    isUpTree() {
      return this.$store.state.upTree
    }
  },
  created() {

    this.zskid = Number(this.$route.query.id)
    this.cid = this.$route.query.cid === undefined ? '' : (this.$route.query.cid)
    this.getMyAddKu()
  },
  methods: {
    // 修改知识库
    editFile() {
      this.zskName = this.$route.query.name;
      this.zskId = this.$route.query.id;
      this.dialogZsk = true;
    },
    // 修改知识库名称弹窗的取消事件
    closeZsk() {
      this.dialogZsk = false;
      this.zskName = "";
      this.zskId = "";
    },
    // 修改知识库名称弹窗的提交事件
    commitZsk() {
      let name = this.zskName;
      let id = this.zskId;
      this.$api.apiContent
        .editZsk({
          mid: this.$store.state.userMid,
          title: this.zskName,
          id: this.zskId
        })
        .then(res => {
          this.closeZsk();

          this.$message.success(res.msg);
          // this.getList()
          this.$router.push({
            path: "/home",
            query: {
              id: id, //  知识库id
              name: name, //    知识库名称
              system: this.$route.query.system
            }
          });
          this.$store.state.upTree = true;
        })
        .catch(e => {
          this.$message.error(e.msg);
          this.closeZsk();
        });
    },
    //删除知识库
    delFile(id) {
      this.$confirm("此操作将删除此知识库以及此知识库下面的所有数据，您确定要删除么？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$api.apiContent
            .deleteZsk({
              mid: this.$store.state.userMid,
              kid: id
            })
            .then(res => {
              this.$message.success(res.msg);
              this.getList();
              this.$store.state.upTree = true;
              this.$router.push({
                path: "/home",

              });
            })
            .catch(e => {
              this.$message.error(e.msg);
            });
        })

    },
    //排序确定
    queding() {
      let arr = []
      this.zskList.map((item, index) => {
        arr.push({
          id: item.id,
          orderlist: index + 1
        })
      })
      this.$api.apiContent.Ranking({
        mid: this.$store.state.userMid,
        data: JSON.stringify(arr)
      }).then(res => {
        if (res.status == 200) {
          this.rank = true;
        }
      })
    },
    //知识库排序上移
    paixu(index) {
      if (index === 0) {
        this.$message.error('它已经是第一个了')
      } else {
        let temp = this.zskList[index - 1]
        Vue.set(this.zskList, index - 1, this.zskList[index])
        Vue.set(this.zskList, index, temp)
        return;
      }


    },
    //下移
    paixu2(index) {
      if (index === (this.zskList.length - 1)) {
        this.$message.error('它已经是最后一个了')
      } else {
        let i = this.zskList[index + 1]
        Vue.set(this.zskList, index + 1, this.zskList[index])
        Vue.set(this.zskList, index, i)
        return;
      }
    },
    //  获取我添加的知识库
    getMyAddKu() {
      this.$api.apiContent.GetAllList({
        mid: this.$store.state.userMid
      }).then(res => {
        if (res.data) {
          this.zskList = [];
          console.log(res.data)
          this.zskList = this.zskList.slice(0, 1)
          res.data.map(item => {
            this.zskList.push({
              id: item.id,
              name: item.name,
              icon: item.system === 1 ? 'iconicon' : item.system === 2 ? 'icongongsi_' :  item.system === 4 ? 'iconbanbenxinjian' :'icon24gf-folder',
              open: false,
              highlightCurrent: false,
              system: item.system,
              share: Number(item.share),
              list: [],
              showSet: false
            })
          })
        }
        if (this.$route.query.id === undefined) {
          this.setPath(this.zskList[0].id, this.zskList[0].name, this.zskList[0].system)
        }
        this.zskList.map((item, index) => {
          if (item.id === this.zskid) {
            item.open = true
            this.GetFolderList(item.id, index, item.open, item.system)
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    //  点击树状图
    handleNodeClick(data) {
      if (data.type === 2) {
        this.setPath2(data.kid, data.id, data.label)
        this.zskList.map(item => {
          item.highlightCurrent = false
          if (item.id === data.kid) {
            item.highlightCurrent = true
          }
        })
      } else if (data.type === 1) {
        this.setPath3(data.kid, data.id, data.label)
        this.zskList.map(item => {
          item.highlightCurrent = false
          if (item.id === data.kid) {
            item.highlightCurrent = true
          }
        })
      }
    },
    //  添加知识库
    addZsk() {
      if (!this.addName) {
        this.$message.error('请填写知识库名称')
      }
      this.$api.apiContent.addZsk({
        mid: this.$store.state.userMid,
        title: this.addName
      }).then(res => {
        this.$message.success(res.msg)
        this.getMyAddKu()
        this.addName = ''
        this.dialogVisible = false
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    //  点击知识库
    isopen(state, index, system) {
      this.zskList.map(item => {
        item.highlightCurrent = false
      })
      //左侧栏目的id
      let id = this.zskList[index].id
      this.setPath(id, this.zskList[index].name, system)
    },
    setPath(id, name, system) {
      if (id === 0) {   //  如果是0 为分享给我
        this.$router.push({
          path: '/home/repositoriesShare',
          query: {
            id: id,      //     知识库id
            name: name  //    知识库名称
          }
        })
      } else {
        if(system === 4){
          this.$router.push({
            path: '/home/contract',
            query: {
              id: id,      //  知识库id
              name: name,  //    知识库名称
              system: system
            }
          })
        }else{
          this.$router.push({
            path: '/home/repositories',
            query: {
              id: id,      //  知识库id
              name: name,  //    知识库名称
              system: system
            }
          })
        }

      }
    },
    setPath2(kid, id, name) {

      this.$router.push({
        path: '/home/list',
        query: {
          id: kid,     //  知识库id
          cid: id,
          name: name  //    文件名称
        }
      })
    },
    setPath3(kid, id, name) {
      this.$router.push({
        path: '/home/detail',
        query: {
          id: kid,     //  知识库id
          cid: id,
          name: name  //    文件名称
        }
      })
    },
    //  获取单个知识库下面的树状图
    GetFolderList(id, index, state, system, clicks) {
      console.log(clicks)
      if (state) {
        this.zskList[index].open = !this.zskList[index].open
        return
      }
      this.$api.apiContent.GetFolderList({
        mid: this.$store.state.userMid,
        team: system,
        kid: id
      }).then(res => {
        if (res.data) {
          res.data.map(item => {
            if (!item.children) {
              item.children = []
            }
            // item.label = item.label
            item.kid = id
          })
          this.zskList[index].list = res.data
          if (state) {
            this.zskList[index].open = true
            this.zskList[index].highlightCurrent = true
            if (this.$route.query.cid) {
              this.$nextTick(() => {
                let _tree = this.$refs['vueTree' + index]
                _tree[0].setCurrentKey(this.$route.query.cid);
              })
            }
          } else {
            this.zskList[index].open = !this.zskList[index].open
          }
        }
      }).catch()
    },
    getList() {
      this.zskid = Number(this.$route.query.id)
    }
  },
  watch: {
    '$route': 'getList',
    isUpTree() {
      if (this.isUpTree) {
        this.$store.state.upTree = false
        this.getMyAddKu()
      }
    }
  }
}
</script>

<style scoped lang="scss">
.jiantou1 {
  /*margin:15px 0 15px 15px;*/
}

.paibutton1 {
  display: inline-block;
  width: 70px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  margin: 30px;
  background: #0a2240;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}

.paibutton {
  display: inline-block;
  width: 70px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  // margin: 30px auto;
  background: #0a2240;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
}

.jiantou {
  /*margin:15px;*/
}

.jiantoudi {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 60px;
  padding: 0 10px;
}

.add-item {
  display: inline-block;
  width: 130px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  margin: 30px;
  background: #0a2240;
  color: #fff;
  cursor: pointer;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;

  i {
    position: relative;
    top: 1px;
    padding-right: 3px;
    font-size: 20px;
    color: #fff;
  }
}

.zhishiku-item {
  line-height: 60px;
  cursor: pointer;
  font-size: 16px;
  position: relative;
    padding-left: 10px;
  //background: #f3f3f3;

}

.zsk-item-tit {
  display: flex;
  color: #fff;

  span {
    flex: 1;
  }

  .iconsangedian-type-1 {
    color: #fff !important;
    height: 60px !important;
    line-height: 60px !important;
  }

  .icon24gf-folder {
    padding-right: 8px;
  }
  .iconbanbenxinjian {
    padding-right: 8px;
  }

  .iconicon {
    padding-right: 8px;
  }

  .icongongsi_ {
    padding-right: 8px;
  }
}

.zsk-item-tit.active {
  background: rgba(255, 255, 255, .2) !important;
  color: #ff9600 !important;

  &:after {
    position: absolute;
    top: 21px;
    right: -14px;
    content: '';
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-left: 14px solid #2f4b6f;
    border-bottom: 8px solid transparent;
    z-index: 19;
  }

  i {
    color: #ff9600 !important;

  }

  .iconsangedian-type-1 {
    color: #ff9600 !important;
  }
}

.set-btn {
  position: absolute;
  top: 60px;
  z-index: 99;
  padding: 10px;
  right: 0;
  width: 150px;
  background-image: linear-gradient(
      37deg, #ffb400, #fc7802), linear-gradient(#0a2240, #0a2240);
  background-blend-mode: normal, normal;
  border-radius: 5px;
  &:after {
    position: absolute;
    top: -20px;
    right: 14px;
    content: '';
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 14px solid #fc7802;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: 19;
  }

  .el-button {
    display: block;
    width: 130px;
    margin: 5px auto;

  }
}
</style>
